import React from "react";
// import { Button } from "react-bootstrap";

//NOTE: I think we can restore this button if desired, it does work
const ParentCompanyDisplayElement = (parentCompanyName, resetValuesCallback) => {
    return (
        <div>
            <div>
                Selected Parent Company: {parentCompanyName}
            </div>
            {/* <div style={{ marginBottom: '20px' }}>
                <Button className="inline-show-result-button" size="sm" onClick={resetValuesCallback}>
                    Reset Selected Parent Company
                </Button>
            </div> */}
        </div>
    );
};

export {
    ParentCompanyDisplayElement
};
